import { useNavigate } from "react-router";
import { NotFoundCard, useBrandToken } from "@repo/ui";

export default function NotFoundPage() {
    const token = useBrandToken();
    const navigate = useNavigate();

    return (
        <div
            style={{
                minHeight: "100dvh",
                display: "grid",
                placeItems: "center",
                padding: 16,
                background: token.colorBgLayout,
            }}
        >
            <NotFoundCard
                size="sm"
                code="404"
                subtitle="Страница не найдена"
                actionText="На главную"
                onAction={() => navigate("/")}
            />
        </div>
    );
}
